export const loadScript = ({ id, url, callback = () => {} }) => {
  const existingScript = document.getElementById(id);
  if (existingScript) {
    callback();
    return;
  }

  let isLoaded = false;

  const head = document.getElementsByTagName('head')[0];
  const el = document.createElement('script');
  const handleLoad = () => {
    if (isLoaded) {
      return;
    }

    isLoaded = true;
    callback();
  };

  el.src = url;
  el.id = id;
  el.async = true;
  el.onload = handleLoad;
  head.insertBefore(el, head.lastChild);
};

export const loadStyle = ({ url }) => {
  const head = document.getElementsByTagName('head')[0];
  const el = document.createElement('link');

  el.href = url;
  el.rel = 'stylesheet';
  el.type = 'text/css';
  head.insertBefore(el, head.lastChild);
};
